var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1221 2C13.9582 2.37314 12.9476 3.07541 12.1973 4H8V9H3V20H17V14.1875C17.0171 14.1876 17.0346 14.1895 17.0518 14.1895C17.7334 14.1894 18.3877 14.0804 19 13.8818V21.0088C18.9998 21.5564 18.5551 21.9999 18.0068 22H1.99316C1.44467 21.9999 1 21.55 1 20.9932V8L7.00293 2H15.1221Z",
    fill: "#787E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15V17H6V15H14Z",
    fill: "#787E82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5957 11C12.036 11.7897 12.6421 12.4716 13.3691 13H6V11H11.5957Z",
    fill: "#787E82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2018 13.205C14.2018 13.205 11.8018 10.805 11.8018 7.80503C11.8018 4.80503 14.2018 2.40503 17.2018 2.40503C20.2018 2.40503 22.6018 4.80503 22.6018 7.80503C22.6018 10.805 20.2018 13.205 17.2018 13.205ZM17.2018 12.105C19.6018 12.105 21.5018 10.205 21.5018 7.80503C21.5018 5.40503 19.6018 3.50503 17.2018 3.50503C14.8018 3.50503 12.9018 5.40503 12.9018 7.80503C12.9018 10.205 14.8018 12.105 17.2018 12.105ZM16.6018 10.005L14.3018 7.70503L15.1018 6.90503L16.6018 8.40503L19.7018 5.40503L20.5018 6.20503L16.6018 10.005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingIcon);
export default __webpack_public_path__ + "static/media/Reporting-icon.52a59350ed1459f0e47c903df55224d7.svg";
export { ForwardRef as ReactComponent };